import { useQuery } from '@tanstack/react-query';
import { FlowTemplatesAPI } from '@newo/api/gateway';
import axios from '@/utils/api/axiosInstance';

const flowTemplatesAPI = new FlowTemplatesAPI(axios);

// GET Flow templates
export const useFlowTemplatesQuery = () =>
    useQuery({
        queryKey: ['flow/templates'],
        queryFn: async () => flowTemplatesAPI.getFlowTemplates()
    });
